import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import id from 'vee-validate/dist/locale/id.json'
import en from 'vee-validate/dist/locale/en.json'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  const enCustomMessage = {
    strong_password: 'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)',
    phoneNumber: 'Phone number must be correctly',
    reserveTime: 'Time must be correctly',
    creditCard: 'Credit card must be correctly',
    creditCardCVN: 'CVN must be correctly',
    max: 'Max. {max} characters',
    max_guest: 'The number of guests cannot exceed {limit}.'
  }
  const idCustomMessage = {
    strong_password: 'Kata sandi harus menggunakan setidaknya: 1 huruf besar, 1 huruf kecil, 1 angka, dan satu karakter khusus (Contoh , . _ & ? )',
    phoneNumber: 'No. Hp harus diisi dengan benar',
    reserveTime: 'Waktu harus diisi dengan benar',
    creditCard: 'Kartu kredit harus diisi dengan benar',
    creditCardCVN: 'CVN harus diisi dengan benar',
    max: 'Max. {max} karakter',
    max_guest: 'Jumlah tamu tidak boleh lebih dari {limit}.'
  }

  const validation = {
    en: {
      fields: {
        name: 'Name',
        email: 'Email',
        emailorphone: 'Email or Phone number',
        current_email: 'E-mail',
        current_password: 'Password',
        password: 'Password',
        phone: 'Phone number',
        current_phone: 'Phone number',
        note: 'Note',
        no_meja: 'No. Table',
        otp_type_email: 'Email',
        otp_type_phone: 'Phone',
        credit_card: 'Credit card',
        credit_card_cvn: 'CVV',
        reserve_time: 'Time',
        gender: 'Gender',
        location_name: 'Location name',
        total_guest: 'Total guest',
        message: 'Pesan'
      },
      validation: Object.assign({}, en.messages, enCustomMessage)
    },
    id: {
      fields: {
        name: 'Nama',
        email: 'Email',
        emailorphone: 'Email atau No. handphone',
        current_email: 'Email',
        current_password: 'Kata sandi',
        password: 'Kata sandi',
        phone: 'No. handphone',
        current_phone: 'No. handphone saat ini',
        note: 'Catatan',
        no_meja: 'Nomor meja',
        otp_type_email: 'Email',
        otp_type_phone: 'Phone',
        credit_card: 'Kartu kredit',
        credit_card_cvn: 'CVV',
        reserve_time: 'Waktu',
        gender: 'Jenis kelamin',
        location_name: 'Nama lokasi/daerah',
        total_guest: 'Jumlah pengunjung',
        message: 'Pesan'
      },
      validation: Object.assign({}, id.messages, idCustomMessage)
    }
  }

  const data = {}
  data.en = { ...validation.en, ...messages.en }
  data.id = { ...validation.id, ...messages.id }
  return data
}

export default new VueI18n({
  locale: Cookies.get(process.env.VUE_APP_COOKIE_KEY + '_Locale') || process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: Cookies.get(process.env.VUE_APP_COOKIE_KEY + '_Locale') || process.env.VUE_APP_I18N_LOCALE,
  messages: loadLocaleMessages()
})
